//@ts-nocheck

import {FC, useState} from 'react'
import {Button} from '_core'
import {useDispatch, useSelector} from 'react-redux'
import {showMessage} from 'app/redux/messageSlice'
import {
  selectRefund,
  selectViewOrder,
  setIsDirty,
  setOrderErrors,
} from 'app/features/orders/redux/order/refundSlice'
import {useNavigate} from 'react-router-dom'
import {RefundOrder} from 'app/features/orders/models/OrderRefundState'
import {RootState} from 'setup'
import eventPublishService from 'app/services/EventPublishService/EventPublishService'
import {eventNames} from 'app/constant'
import ConfirmationDialog from '_core/components/ConfirmationDialog'
import {refundEntirePOSOrder} from 'app/features/orders/services/RefundService'
import { defaultPaymentErrorMessage } from 'app/constant/payment'

interface Props {
  title?: string
  disabled?: boolean
}

const PayConnectFullRefundButton: FC<Props> = ({title = 'Refund Entire Order', disabled}) => {
  const dispatch = useDispatch()
  const history = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [show, setShow] = useState(false)
  const refund = useSelector<RootState, RefundOrder>(selectRefund)
  const order = useSelector<RootState, RefundOrder>(selectViewOrder)

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true)
      await handleRefund()
    } catch (err:any) {
      console.error(err)
      dispatch(
        showMessage({
          text: defaultPaymentErrorMessage(),
          variant: 'error',
        })
      )
      setIsSubmitting(false)
    }
  }

  const handleRefund = async () => {
    const callback = async (posOrder: any) => {
      if (window.corksy && window.corksy.paymentRelayClient) {
        await window.corksy.paymentRelayClient.mfOrderReturn(posOrder, handleCompleteReturn)
      } else {
        dispatch(
          showMessage({
            text:defaultPaymentErrorMessage(),
            variant: 'error',
          })
        )
      }
    }
    const model = {id: refund.id, orderNumber: order.orderNumber}
    await refundEntirePOSOrder(model, callback)
  }

  const handleCompleteReturn = async (paymentResponse) => {
    const {error} = paymentResponse
    if (error) {
      dispatch(setOrderErrors([error.message]))
      dispatch(
        showMessage({
          text: defaultPaymentErrorMessage(error.message),
          variant: 'error',
        })
      )
    } else {
      dispatch(setIsDirty(false))
      dispatch(showMessage({text: 'Order cancelled successfully', variant: 'success'}))
      await eventPublishService.publish({message: {id: refund.id}, name: eventNames.orderCancel})
      history(`/orders/${refund.id}/fulfillments/view`)
      handleDialogClose()
    }
    setIsSubmitting(false)
  }

  const handleDialogOpen = () => {
    setShow(true)
  }

  const handleDialogClose = () => {
    setShow(false)
  }

  return (
    <div className='me-5'>
      <Button
        id='btnSave'
        type='button'
        title={title}
        isSubmitting={isSubmitting}
        className='btn-primary btn-primary-active'
        onClick={handleDialogOpen}
        disabled={disabled}
      />

      {show && (
        <ConfirmationDialog
          show={show}
          title='Refund Entire Order'
          message='This will refund the entire order amount to the customer. Are you sure you want to proceed?'
          onClose={handleDialogClose}
          onConfirm={handleSubmit}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  )
}

export default PayConnectFullRefundButton
